<template>
  <!-- 律师团队 -->
  <section class="bjzc-home-team">
    <h2 class="uk-text-center">{{ $t('sections.team') }}</h2>
    <div class="uk-container">
      <!-- 屏幕宽度 < 960px，开启slider滚动模式，每项宽度为4/5 -->
      <div class="uk-hidden@m" uk-slider="finite: true">
        <ul class="bjzc-team-list uk-slider-items uk-grid" uk-grid>
          <li v-for="lawyer in lawyerList" :key="lawyer.id" class="uk-width-4-5">
            <TeamListItem :lawyer="lawyer" />
          </li>
        </ul>
      </div>
      <!-- 屏幕宽度 >= 960px，各项平分空间，最多三条，无滚动 -->
      <div class="uk-visible@m">
        <ul class="bjzc-team-list uk-grid" uk-grid>
          <li v-for="lawyer in lawyerList.slice(0, 3)" :key="lawyer.id" class="uk-width-expand">
            <TeamListItem :lawyer="lawyer" />
          </li>
        </ul>
      </div>
    </div>
    <div class="more-btn-wrapper uk-text-center">
      <button class="bjzc-button" @click="more">
        {{ $t('messages.more_lawyers') }}
      </button>
    </div>
  </section>
</template>

<script>
import TeamListItem from './TeamListItem.vue'

export default {
  name: '',
  components: { TeamListItem },
  data() {
    return {
      lawyerList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.$axios.get('lawyers').then(res => {
        this.lawyerList = res.data
      })
    },
    more() {
      this.$router.push({ name: 'Team' })
    }
  }
}
</script>

<style lang="scss">
.bjzc-home-team {
  background-image: url('~@/assets/images/bg/section-2.png');
  background-position: 0% bottom;
  background-repeat: repeat-x;
}
@media (max-width: ($screen-width-m - 1)) {
  .bjzc-home-team .bjzc-team-list .uk-grid {
    margin-left: -10px;
  }
  .bjzc-home-team .bjzc-team-list .uk-grid > * {
    padding-left: 10px;
  }
}
</style>
